import { JobTaskDetailSchema } from "@augmodo/lebron-browser-client";
import { Badge, Card, Text, Stack } from "@mantine/core";
import { HEADER_HEIGHT, RESULTS_SIDEBAR_WIDTH } from "@/config/data";
import { ActionStatusBadge } from "./ActionStatusBadge";
import { ConfirmationQaSidebarActions } from "./ConfirmationQaSidebarActions";
import { ViewMode } from "@/types";

export const ConfirmationResultsSidebar = ({
  task,
  mode,
  testing,
}: {
  task: JobTaskDetailSchema;
  mode?: ViewMode;
  testing?: boolean;
}) => {
  const isCorrect = (task as any)?.result?.is_correct;
  const qaConfirmationCorrect = (task as any)?.result?.qa_confirmation_correct;
  const topOffset = mode?.includes("qa") ? HEADER_HEIGHT : HEADER_HEIGHT * 2;

  const sidebarTitle =
    mode === ViewMode.CONFIRMATION_QA_FEEDBACK ? "QA Result" : "Result";

  return (
    <div
      className="fixed right-0 bottom-0"
      style={{ top: topOffset - 2, width: RESULTS_SIDEBAR_WIDTH }}
    >
      <Card
        title="Results"
        className="w-full h-full"
        shadow="sm"
        padding="lg"
        withBorder
      >
        <Stack gap="md">
          <Text size="lg" fw={600}>
            {sidebarTitle}
          </Text>

          {testing && (
            <Badge color="yellow" variant="light" size="lg">
              Testing
            </Badge>
          )}

          {isCorrect !== undefined && (
            <div>
              <ActionStatusBadge
                resultField="is_correct"
                task={task}
                size="lg"
              />
            </div>
          )}

          {qaConfirmationCorrect !== undefined && (
            <div>
              <Text size="sm" c="dimmed" mb="xs">
                Was the task done correctly?
              </Text>
              <ActionStatusBadge
                resultField="qa_confirmation_correct"
                task={task}
                size="lg"
              />
            </div>
          )}
        </Stack>
        {mode?.includes("qa") && (
          <ConfirmationQaSidebarActions task={task} mode={mode} />
        )}
      </Card>
    </div>
  );
};
